import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { store } from 'react-notifications-component';
import Select from '../../select/select_v2';
import Button from '../../button/button_v2';
import AddLocalAplicacao from '../../produtores/fazendas';
import identifyErrorMenssage from '../../../services/identifyErrorMenssage';

// Pedido veio da Omie sem CNPJ de entrega (sem fazenda vinculada, ver
// resolveOuCriaFazenda/criarRascunho no omie.service.ts) - deixa o usuário escolher uma
// fazenda já existente do produtor, ou cadastrar uma nova sem sair da tela (reusa o
// mesmo form de components/produtores/fazendas usado na tela de Produtores - ele já
// aceita produtor/isModal como props diretas e não toca props.loc.history quando
// isModal===true, só chama updateModal()).
const ModalVincularFazenda = ({ orderId, produtorId, onClose, onVinculado }) => {
    const [modo, setModo] = useState('selecionar'); // 'selecionar' | 'cadastrar'
    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [fazendas, setFazendas] = useState([]);
    const [fazendaSelecionada, setFazendaSelecionada] = useState(null);

    const carregarFazendas = async () => {
        try {
            const response = await api.get(`/produtor-fazendas/${produtorId}`);
            const lista = response?.data?.data?.agro_farms || [];
            setFazendas(lista);
            return lista;
        } catch (error) {
            store.addNotification({
                title: 'Erro!',
                message: identifyErrorMenssage(error),
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 6000, onScreen: true }
            });
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (produtorId) carregarFazendas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [produtorId]);

    const vincularFazendaId = async (agroFarmId) => {
        setSalvando(true);
        try {
            await api.put(`/omie/rascunhos/${orderId}/fazenda`, {
                agro_farm_id: agroFarmId,
            });
            store.addNotification({
                title: 'Sucesso!',
                message: 'Fazenda vinculada ao pedido com sucesso!',
                type: 'success',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 4000, onScreen: true }
            });
            onVinculado?.();
            setTimeout(() => window.location.reload(), 1500);
        } catch (error) {
            store.addNotification({
                title: 'Erro!',
                message: identifyErrorMenssage(error),
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animated', 'fadeIn'],
                animationOut: ['animated', 'fadeOut'],
                dismiss: { duration: 6000, onScreen: true }
            });
        } finally {
            setSalvando(false);
        }
    };

    // Callback do form de cadastro - ele não devolve o id da fazenda criada, então
    // recarrega a lista e pega a de maior id (mais recente) pra vincular sozinho.
    const handleFazendaCriada = async () => {
        const lista = await carregarFazendas();
        setModo('selecionar');
        if (lista.length === 0) return;
        const maisRecente = lista.reduce((max, f) => (f.id > max.id ? f : max), lista[0]);
        setFazendaSelecionada({ value: maisRecente.id, label: maisRecente.nome });
        await vincularFazendaId(maisRecente.id);
    };

    if (modo === 'cadastrar') {
        return (
            <div style={{ padding: '24px', width: '100%', display: 'flex',flexDirection:'column', alignItems: 'center', justifyContent: "center" }}>

                <AddLocalAplicacao
                    isFocus={true}
                    isModal={true}
                    produtor={String(produtorId)}
                    loc={{}}
                    updateModal={handleFazendaCriada}
                />
                <div style={{ textAlign: 'center', marginTop: '16px', width:'400px' }}>
                    <Button
                        value="VOLTAR"
                        outline={true}
                        width="auto"
                        height="44px"
                        onClick={() => setModo('selecionar')}
                    />
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '24px', minWidth: '320px' }}>
            <h4 style={{ textAlign: 'center', marginBottom: '16px' }}>
                Esse pedido não tem fazenda vinculada
            </h4>
            <p style={{ textAlign: 'center', marginBottom: '24px', color: '#6b7280' }}>
                Selecione uma fazenda já cadastrada do produtor pra vincular ao pedido.
            </p>

            <Select
                label={loading ? 'Carregando...' : 'Fazenda'}
                value={fazendaSelecionada}
                onChange={setFazendaSelecionada}
                options={fazendas.map((f) => ({ value: f.id, label: f.nome }))}
                disabled={loading}
            />

            <p style={{ margin: '16px 0', textAlign: 'center' }}>
                <button
                    type="button"
                    onClick={() => setModo('cadastrar')}
                    style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', textDecoration: 'underline', padding: 0, font: 'inherit' }}
                >
                    Não tem a fazenda? Cadastre uma nova
                </button>
            </p>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '24px' }}>
                <Button
                    value="CANCELAR"
                    outline={true}
                    width="auto"
                    height="44px"
                    onClick={onClose}
                />
                <Button
                    value="VINCULAR"
                    width="auto"
                    height="44px"
                    loading={salvando}
                    disabled={!fazendaSelecionada?.value}
                    onClick={() => vincularFazendaId(fazendaSelecionada.value)}
                />
            </div>
        </div>
    );
};

export default ModalVincularFazenda;
